import { ProfileName } from "@kwp/contracts";

/** The Profile form's name, checked as the api will check it (trimmed, 1–80 characters, one line). */
export function checkName(raw: string): { ok: true; name: string } | { ok: false; message: string } {
  const parsed = ProfileName.safeParse(raw);
  if (parsed.success) return { ok: true, name: parsed.data };
  const [issue] = parsed.error.issues;
  if (issue === undefined) throw new Error("a failed parse without an issue");
  return { ok: false, message: issue.message };
}
